export enum ConfigLookupType {
  AUTO_PAY = <any>'AUTO_PAY',
  DEFAULT_END_DATE_PLUS_DAYS = <any>'DEFAULT_END_DATE_PLUS_DAYS',
  TRANSIENT_RESERVATIONS_MAX_RESULT = <any>'TRANSIENT_RESERVATIONS_MAX_RESULT',
  PREPAYMENT_MIN_AMOUNT = <any>'PREPAYMENT_MIN_AMOUNT',
  ALL = <any>'ALL'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/config/config-lookup-type.ts